import React from 'react';
import { useTranslation } from 'react-i18next';
import './Impressum.css';

export const Impressum = () => {
  const { i18n } = useTranslation();
  const isGerman = i18n.language === 'de';

  return (
    <div className="impressum-page">
      <div className="impressum-container">
        <h1>{isGerman ? 'Impressum' : 'Legal Notice'}</h1>
        
        <div className="owner-section">
          <div className="owner-image">
            <img 
              src="https://customer-assets.emergentagent.com/job_91f93426-ea10-46d2-8a07-bd20f6d5069b/artifacts/e0yvas0q_image.png" 
              alt="Alberto Rigotti" 
              className="owner-photo"
            />
          </div>
          <div className="owner-info">
            <h2>Alberto Rigotti</h2>
            <p className="owner-title">{isGerman ? 'Inhaber' : 'Owner'}</p>
            <p className="owner-company">MPG Versandzentrum</p>
          </div>
        </div>

        {isGerman ? (
          <>
            <section>
              <h2>Angaben gemäß § 5 TMG</h2>
              <p><strong>Alberto Rigotti</strong></p>
              <p>MPG Versandzentrum</p>
            </section>

            <section>
              <h2>Kontakt</h2>
              <p><strong>E-Mail:</strong> info@alberto.at</p>
              <p><strong>Website:</strong> <a href="https://mpgshipping.info" target="_blank" rel="noopener noreferrer">mpgshipping.info</a></p>
            </section>

            <section>
              <h2>Haftungsausschluss</h2>
              
              <h3>Haftung für Inhalte</h3>
              <p>Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
              
              <h3>Haftung für Links</h3>
              <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen.</p>
            </section>

            <section>
              <h2>Urheberrecht</h2>
              <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.</p>
            </section>

            <section>
              <h2>Datenschutz</h2>
              <p>Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis.</p>
              <p>Weitere Informationen finden Sie in unserer <a href="/privacy">Datenschutzerklärung</a>.</p>
            </section>
          </>
        ) : (
          <>
            <section>
              <h2>Information According to § 5 TMG</h2>
              <p><strong>Alberto Rigotti</strong></p>
              <p>MPG Shipping Center</p>
            </section>

            <section>
              <h2>Contact</h2>
              <p><strong>Email:</strong> info@alberto.at</p>
              <p><strong>Website:</strong> <a href="https://mpgshipping.info" target="_blank" rel="noopener noreferrer">mpgshipping.info</a></p>
            </section>

            <section>
              <h2>Disclaimer</h2>
              
              <h3>Liability for Content</h3>
              <p>The contents of our pages have been created with the greatest care. However, we cannot guarantee the accuracy, completeness, and timeliness of the content.</p>
              
              <h3>Liability for Links</h3>
              <p>Our offer contains links to external third-party websites over whose content we have no influence. Therefore, we cannot accept any liability for this external content.</p>
            </section>

            <section>
              <h2>Copyright</h2>
              <p>The content and works created by the site operators on these pages are subject to German copyright law. The reproduction, editing, distribution, and any kind of exploitation outside the limits of copyright require the written consent of the respective author or creator.</p>
            </section>

            <section>
              <h2>Privacy</h2>
              <p>The use of our website is generally possible without providing personal data. As far as personal data (for example, name, address, or email addresses) is collected on our pages, this is always done on a voluntary basis wherever possible.</p>
              <p>For more information, please see our <a href="/privacy">Privacy Policy</a>.</p>
            </section>
          </>
        )}
      </div>
    </div>
  );
};
